export class SegmentStat {
	public nodes: SegmentStatNode[]
	public nodeType: string
	public categories: SegmentStatCategory[]

	constructor(data: {
		nodes: SegmentStatNode[]
		nodeType: string
		categories: SegmentStatCategory[]
	}) {
		this.nodes = data.nodes
		this.nodeType = data.nodeType
		this.categories = data.categories
	}

	static create(data: Partial<SegmentStat>) {
		const defaultData = {
			nodes: [],
			nodeType: '',
			categories: [],
		}

		return new SegmentStat({
			...defaultData,
			...data,
		})
	}
}

export class SegmentStatNode {
	public name: string
	public proportion: number

	constructor(data: { name: string; proportion: number }) {
		this.name = data.name
		this.proportion = data.proportion
	}

	static create(data: Partial<SegmentStatNode>) {
		const defaultData = {
			name: '',
			proportion: 0,
		}

		return new SegmentStatNode({
			...defaultData,
			...data,
		})
	}
}

export class SegmentStatCategory {
	public nodes: SegmentStatNode[]
	public category: string

	constructor(data: { nodes: SegmentStatNode[]; category: string }) {
		this.nodes = data.nodes
		this.category = data.category
	}

	static create(data: Partial<SegmentStatCategory>) {
		const defaultData = {
			nodes: [],
			category: '',
		}

		return new SegmentStatCategory({
			...defaultData,
			...data,
		})
	}
}
